export default __webpack_public_path__ + "static/media/c_1.5eb1e8ce.svg";